/* ═════════════════════════════════════════════════════════════════════════════
   SRC/COMPONENTS/TABVERBATINSVIEW/DATATRANSFORMS.JS — funções puras de dados
   ─────────────────────────────────────────────────────────────────────────────
   O QUE FAZ
   VerbatinsView (./index.jsx) é uma página de metodologia — conteúdo quase
   todo estático. As poucas peças de lógica embutida no JSX (classificar o
   tipo de pergunta do questionário e formatar as faixas/barras da escala de
   referência CSAT/CES) são extraídas aqui pra poderem ser testadas
   isoladamente, no mesmo padrão de tabTrendsView/dataTransforms.js.

   USADO POR
   ./index.jsx (VerbatinsView).
   ═══════════════════════════════════════════════════════════════════════════ */

/**
 * Rótulo do tipo de indicador de uma pergunta do questionário (NPS/CES/CSAT).
 * Qualquer `tipo` que não seja "nps" nem "ces" é tratado como CSAT — mesmo
 * fallback usado no questionário completo (11 etapas + NPS).
 */
export function questTipoLabel(tipo) {
  if (tipo === "nps") return "NPS";
  if (tipo === "ces") return "CES";
  return "CSAT";
}

/**
 * Texto da faixa percentual de uma linha da ESCALA de referência
 * (ex.: "80% ou mais", "70% a 79%", "0% a 39% (abaixo de 40%)").
 * i=0 é tratado como caso especial ("X% ou mais"); as demais linhas usam o
 * min da própria linha e o min da linha anterior (−1) como teto da faixa.
 */
export function escalaRangeLabel(escala, i) {
  const base =
    i === 0
      ? "80% ou mais"
      : `${escala[i].min}% a ${escala[i - 1].min - 1}%`;
  return base + (escala[i].min === 0 ? " (abaixo de 40%)" : "");
}

/**
 * Largura (%) da barra visual de cada linha da escala de referência
 * CSAT/CES, por índice. A escala tem 6 faixas; qualquer índice fora da
 * tabela cai na largura da última faixa (37%).
 */
const ESCALA_BAR_WIDTHS = ["100%", "87%", "75%", "62%", "50%", "37%"];
export function escalaBarWidth(i) {
  return ESCALA_BAR_WIDTHS[i] ?? ESCALA_BAR_WIDTHS[ESCALA_BAR_WIDTHS.length - 1];
}
